import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';
export default function newsletter(){
    $("[newsletter-form]").on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")
        let form = $(this);
        let fields = form.serializeArray();
        let validation = new FormValidate(fields, 1, form.attr('id'));
        const modalSuccess = document.getElementById('success-message-forms');
        const modalSuccessDescription = document.querySelector('#success-message-forms .description');
        const modalError = document.getElementById('error-message-forms');
        const modalDescription = document.querySelector('#error-message-forms .description');

        validation.validateAll(fields);
        let error = validation.hasError();
        
        MessageHandler.removeAllFormFailMessages()
        let terms = $("#" + form.attr('id')).find("input[type='checkbox']");
        let termsChecked = terms.prop('checked') == true;
        if (!error && !termsChecked){
            error = true
            const id = terms.attr('idError');
            MessageHandler.showFailMessage(id, false);
            return false;
        }

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(errorMessageId, false);
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            
            class Newsletter extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $("[newsletter-form]").trigger("reset");
                        $("[newsletter-form]").removeAttr('disabled');
                        modalSuccess.classList.add("open-modal");
                        modalSuccessDescription.innerHTML = data.txt;
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $("[newsletter-form]").removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    modalError.classList.add("open-modal");
                    $("[newsletter-form]").removeAttr('disabled');
                };
            }
            let ajax = new Newsletter(form, type, url, dataType, form.serialize());
            ajax.send();
        }

        return false;
    });
}
